export const Colors = {
    brand: '#9f250a',
    accent: '#53d585',
    grey100: '#ededed',
    grey200: '#c8c8c8',
    grey500: '#8e8e8e',
    grey700: '#666666',
    grey800: '#44484B',
    grey900: '#2f2f2f',
};
